import { render, staticRenderFns } from "./ProductsAtGlanceItem.vue?vue&type=template&id=4999e15d&scoped=true&"
import script from "./ProductsAtGlanceItem.vue?vue&type=script&lang=js&"
export * from "./ProductsAtGlanceItem.vue?vue&type=script&lang=js&"
import style0 from "./ProductsAtGlanceItem.vue?vue&type=style&index=0&id=4999e15d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4999e15d",
  null
  
)

export default component.exports